import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "admin-list-section" };
const _hoisted_2 = { class: "section-header" };
const _hoisted_3 = { class: "header-actions" };
const _hoisted_4 = ["disabled"];
const _hoisted_5 = { class: "search-box" };
const _hoisted_6 = ["placeholder"];
const _hoisted_7 = {
    key: 0,
    class: "loading"
};
const _hoisted_8 = {
    key: 1,
    class: "items-list"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "list-item-content" };
const _hoisted_11 = { class: "item-info" };
const _hoisted_12 = { class: "item-name" };
const _hoisted_13 = {
    key: 2,
    class: "empty-state"
};
import { ref, computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdminListSection',
    props: {
        title: {},
        items: { default: () => [] },
        selectedId: { default: null },
        loading: { type: Boolean, default: false },
        searchPlaceholder: { default: 'Search...' },
        emptyMessage: { default: 'No items found' },
        showNewButton: { type: Boolean, default: false },
        showRefresh: { type: Boolean, default: true },
        newButtonText: { default: 'New Item' },
        searchFields: { default: () => ['name', 'title'] }
    },
    emits: ["select", "refresh", "new"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const searchQuery = ref('');
        const filteredItems = computed(() => {
            if (!props.items)
                return [];
            if (!searchQuery.value)
                return props.items;
            const query = searchQuery.value.toLowerCase();
            return props.items.filter((item) => {
                return props.searchFields.some((field) => {
                    const value = getNestedValue(item, field);
                    return value && value.toString().toLowerCase().includes(query);
                });
            });
        });
        function getNestedValue(obj, path) {
            return path.split('.').reduce((current, key) => current?.[key], obj);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "header-actions"),
                        (_ctx.showRefresh)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "action-btn secondary",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('refresh'))),
                                disabled: _ctx.loading
                            }, " 🔄 Refresh ", 8, _hoisted_4))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchQuery).value = $event)),
                        type: "text",
                        placeholder: _ctx.searchPlaceholder,
                        class: "search-input"
                    }, null, 8, _hoisted_6), [
                        [_vModelText, searchQuery.value]
                    ])
                ]),
                (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "spinner" }, null, -1)),
                        _createElementVNode("p", null, "Loading " + _toDisplayString(_ctx.title.toLowerCase()) + "...", 1)
                    ]))
                    : (filteredItems.value && filteredItems.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: item.id,
                                    class: _normalizeClass(["list-item", { active: _ctx.selectedId && _ctx.selectedId === item.id }]),
                                    onClick: ($event) => (_ctx.$emit('select', item))
                                }, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _renderSlot(_ctx.$slots, "item", { item: item }, () => [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, _toDisplayString(item.name || item.title || 'Untitled'), 1)
                                            ])
                                        ])
                                    ]),
                                    (_ctx.$slots['item-actions'])
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "item-actions",
                                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"]))
                                        }, [
                                            _renderSlot(_ctx.$slots, "item-actions", { item: item })
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 10, _hoisted_9));
                            }), 128))
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.emptyMessage), 1)),
                (_ctx.showNewButton)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "action-btn primary full-width mt-10",
                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('new')))
                    }, " + " + _toDisplayString(_ctx.newButtonText), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
